import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { CiCdConfigService } from "src/cicd/ci-cd-config.service";

@Injectable({
  providedIn: "root"
})
export class ReintegrosService {
  private urlApi: string;
  public token: any;
  public userData: any;
  public headers: any;

  constructor(private http: HttpClient,
    private readonly ciCd: CiCdConfigService
  ) {
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi } = apis;
      this.urlApi = urlApi;
    });
  }

  getWebContracts(data: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    data.id_pais = this.userData.v_pais;
    data.id_pais_af = this.userData.v_pais;
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.tipo_documento_af = this.userData.v_tipo_documento;
    data.documento_af = this.userData.v_documento;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.get(`${this.urlApi}/pr_consulta_contratos_web`, options);
  }

  getDebtsAffiliate(data: any, affiliate?: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    data.id_pais = this.userData.v_pais;
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.contrato = affiliate.contrato;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.get(
      `${this.urlApi}/pr_consulta_cartera_afiliado_Afi`,
      options
    );
  }

  getTotalDebts(data: any, affiliate?: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    data.id_pais = this.userData.v_pais;
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.contrato = affiliate.contrato;
    data.fecha_inicial = affiliate.fecha_inicial;
    data.fecha_final = affiliate.fecha_final;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.get(
      `${this.urlApi}/pr_consulta_cartera_afiliado_Tot`,
      options
    );
  }

  getDebtsDetails(data: any, affiliate?: any, detail?: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    data.id_pais = this.userData.v_pais;
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.contrato = affiliate.contrato;
    data.fecha_inicial = affiliate.fecha_inicial;
    data.fecha_final = affiliate.fecha_final;
    data.marca = detail;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.get(
      `${this.urlApi}/pr_consulta_cartera_afiliado_Det`,
      options
    );
  }

  // Gestion
  getManagement(data: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    data.pais = this.userData.v_pais;
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.get(`${this.urlApi}/gestiones_adelantadas`, options).pipe(
      map((resp: any) => {
        return resp.GESTION_ADELANTADA[0];
      })
    );
  }

  // GReintegros
  getRefunds(data?: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    data.pais = this.userData.v_pais;
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.get(`${this.urlApi}/consulta_reintegros`, options).pipe(
      map((resp: any) => {
        return resp.REINTEGROS;
      })
    );
  }
}
